{
  "name": "Proto Meadow",
  "width": 24,
  "height": 14,
  "legend": {
    ".": "open",
    "T": "forest"
  },
  "lumberPerTile": 100,
  "startingResources": {
    "gold": 200,
    "lumber": 100
  },
  "rows": [
    "TTTTTTTTTTTTTTTTTTTTTTTT",
    "T......................T",
    "T..TT..................T",
    "T..TT.......TTT........T",
    "T...........TTT........T",
    "T......................T",
    "T..........T...........T",
    "T..........T.....TT....T",
    "T..........T.....TT....T",
    "T......TTTTT...........T",
    "T......................T",
    "T....................T.T",
    "T......................T",
    "TTTTTTTTTTTTTTTTTTTTTTTT"
  ],
  "starts": [
    {
      "x": 2,
      "y": 5
    }
  ],
  "mines": [
    {
      "x": 18,
      "y": 3,
      "gold": 5000
    },
    {
      "x": 13,
      "y": 10,
      "gold": 2500
    }
  ],
  "units": [
    {
      "def": "melee",
      "owner": 1,
      "x": 20,
      "y": 7
    },
    {
      "def": "melee",
      "owner": 1,
      "x": 21,
      "y": 8
    },
    {
      "def": "melee",
      "owner": 1,
      "x": 20,
      "y": 9
    }
  ]
}
